var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComponents = function SvgComponents(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 84.25 61.99"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:var(--konflux-icon-color, #1A1A1A);stroke-linecap:round;stroke-linejoin:round;stroke-width:4px;}.cls-2{fill:var(--konflux-primary-color, #FF9D76);stroke-width:0px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15.49,24.43l11.47-13.83c1.46-1.6,3.51-2.54,5.67-2.59l29.15.35c2.46-.06,4.81,1.04,6.35,2.96l13.39,15.67c4.32,5.38,3.2,9.67-1.35,14.86l-15.29,17.44c-1.5,1.71-3.67,2.7-5.95,2.7h-25.47c-2.5,0-4.85-1.18-6.35-3.19l-12.49-16.78c-3.96-5.31-3.6-12.68.86-17.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2,28h11.14M24.29,28h-11.14M13.14,28v-11.14M13.14,28v11.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.79,5.71l.91-1.04c2.96-3.38,8.22-3.38,11.18,0l16.13,18.43c2.45,2.8,2.45,6.98,0,9.78l-16.13,18.43c-2.96,3.38-8.22,3.38-11.18,0l-.91-1.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.86,54l18.14-21.17c2.38-2.78,2.38-6.89,0-9.67L42.86,2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.71,2l18.14,21.17c2.38,2.78,2.38,6.89,0,9.67l-18.14,21.17"
  }))));
};
export default SvgComponents;